import {Button} from 'letrus-ui';
import {useLocation, useNavigate} from 'react-router-dom';
import styles from './SubmitCompositionButton.module.scss';

interface SubmitCompositionButtonProps {
  parentId?: number;
  className?: string;
  usesAiComp: boolean;
  isFinished: boolean;
  onClick(status: string): void;
  isMultigenreRewriting: boolean;
  disabled?: boolean;
}

function SubmitCompositionButton({
  onClick,
  parentId,
  className,
  usesAiComp,
  isFinished,
  isMultigenreRewriting,
  disabled = false,
}: SubmitCompositionButtonProps) {
  const navigate = useNavigate();
  const {search} = useLocation();

  return (
    <div className={`${styles.wrapper} ${className}`}>
      {isMultigenreRewriting && (
        <Button
          theme="blue"
          variant="primary"
          onClick={() => {
            const route = usesAiComp
              ? `/atividades/escrita/${parentId}/devolutiva/central`
              : `/atividades/escrita/${parentId}/nova_devolutiva/apresentacao`;
            navigate({pathname: route, search});
          }}
        >
          Ver correção da escrita
        </Button>
      )}

      <Button
        theme="blue"
        variant="primary"
        disabled={disabled}
        onClick={() => onClick(isFinished ? 'finished' : 'writing')}
      >
        {isFinished ? 'Ir para próxima etapa' : 'Enviar redação'}
      </Button>
    </div>
  );
}

export default SubmitCompositionButton;
